import { render, staticRenderFns } from "./FriendshipIcon.vue?vue&type=template&id=37a3b553&scoped=true"
import script from "./FriendshipIcon.vue?vue&type=script&lang=ts"
export * from "./FriendshipIcon.vue?vue&type=script&lang=ts"
import style0 from "./FriendshipIcon.vue?vue&type=style&index=0&id=37a3b553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3b553",
  null
  
)

export default component.exports